var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 20.438V17.1255C11.4375 15.9864 12.3609 15.063 13.5 15.063V15.063C14.6391 15.063 15.5625 15.9864 15.5625 17.1255V20.438",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8814 9.46205C14.0689 8.83011 12.9311 8.83011 12.1186 9.46206L8.93113 11.9412C8.38306 12.3675 8.0625 13.0229 8.0625 13.7173V19.0625C8.0625 19.4077 8.34232 19.6875 8.6875 19.6875H11.25V21.1875H8.6875C7.51389 21.1875 6.5625 20.2361 6.5625 19.0625V13.7173C6.5625 12.5601 7.09677 11.4677 8.01022 10.7572L11.1977 8.27803C12.5519 7.22479 14.4481 7.22479 15.8023 8.27803L18.9898 10.7572C19.9032 11.4677 20.4375 12.5601 20.4375 13.7173V19.0625C20.4375 20.2361 19.4861 21.1875 18.3125 21.1875H15.75V19.6875H18.3125C18.6577 19.6875 18.9375 19.4077 18.9375 19.0625V13.7173C18.9375 13.0229 18.6169 12.3675 18.0689 11.9412L14.8814 9.46205Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8b2755ca.svg";
export { ForwardRef as ReactComponent };